import {ResourceMultimediaPipe} from "@utils/image/resource.multimedia.pipe";
import {
  CreateRessourceMultimediaDto,
  GestionCategorieDto,
  IGestionCatalogueWebServiceClient,
  MultilingualDto,
  SaveCategorieDto
} from "@resources/resources";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AsiFileService} from "@asi-ngtools/lib";
import {TranslateService} from "@ngx-translate/core";
import {ArianeElement, ArianeStore, ModalService} from "@digicerba/common";

@Component({
  selector: 'enregistrement-categorie-component',
  templateUrl: './enregistrement.categories.component.html',
  host: { 'class': 'page' }
})
export class EnregistrementCategorieComponent {

  categorieForm: FormGroup;
  categorie: GestionCategorieDto;
  imageSrc: string;

  constructor(private arianeStore: ArianeStore, private translateService: TranslateService,
    private activatedRoute: ActivatedRoute, private router: Router, private fb: FormBuilder,
    private modalService: ModalService, private gestionCatalogueWebServiceClient: IGestionCatalogueWebServiceClient, private fileUtils: AsiFileService, private resourcePipe: ResourceMultimediaPipe) {

  }

  private initArianne(categorie: GestionCategorieDto) {
    let categorieLabel = categorie && categorie.libelle.fr || "";
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.ADMINISTRATION.administration",
        route: "/administration"
      },
      {
        libelle: "ARIANNE.ADMINISTRATION.categories",
        route: "/administration/categories"
      },
      {
        libelle: this.translateService.instant("ARIANNE.ADMINISTRATION.category", { identifiant: categorieLabel }),
        route: "/administration/enregistrement/categorie/" + (categorie != null ? categorie.id : "")
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.categorie = this.activatedRoute.snapshot.data['categorie'];

    this.initArianne(this.categorie);

    if (this.categorie) {
      this.categorieForm = this.fb.group({
        titre: [this.categorie.libelle.fr, Validators.required],
        ordre: [this.categorie.order, Validators.required],
        photo: [null, Validators.required]
      });

      this.imageSrc = this.resourcePipe.transform(this.categorie.imageId);
    } else {
      this.categorieForm = this.fb.group({
        titre: [null, Validators.required],
        ordre: [null, Validators.required],
        photo: [null, Validators.required]
      });
    }
  }

  goCategories() {
    this.router.navigate(['cerba/administration/categories']);
  }

  submit() {
    let newCategorie = new SaveCategorieDto;

    let label = new MultilingualDto;

    label.fr = this.categorieForm.value.titre;

    newCategorie.label = label;
    newCategorie.order = this.categorieForm.value.ordre;

    let photo = new CreateRessourceMultimediaDto;
    let fichier: File = this.categorieForm.value.photo;

    this.fileUtils.fileToBase64(fichier).subscribe(result => {
      result = result.substring(result.indexOf(",") + 1);

      photo.content = result.toString();
      photo.name = fichier.name;
      photo.mimeType = fichier.type;
      photo.size = fichier.size;
      newCategorie.photo = photo;

      if (this.categorie) {
        if (this.categorie.id) {
          this.gestionCatalogueWebServiceClient.updateCategorie(this.categorie.id, newCategorie).subscribe(result => {
            let dialog = this.modalService.openInfoDialog("MODAL.ENREGISTREMENT_CATEGORIE.title", "MODAL.ENREGISTREMENT_CATEGORIE.message",
              "MODAL.ENREGISTREMENT_CATEGORIE.confirm");
            dialog.onDialogClose().subscribe(() => {
              this.router.navigate(['cerba/administration/categories']);
            });
          });
          return;
        }
      }
      this.gestionCatalogueWebServiceClient.createCategorie(newCategorie).subscribe(result => {
        let dialog = this.modalService.openInfoDialog("MODAL.ENREGISTREMENT_CATEGORIE.title", "MODAL.ENREGISTREMENT_CATEGORIE.message",
          "MODAL.ENREGISTREMENT_CATEGORIE.confirm");
        dialog.onDialogClose().subscribe(() => {
          this.router.navigate(['cerba/administration/categories']);
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/categories/enregistrement/enregistrement.categories.component.ts